import axios from "axios";

type IPAddressFunctionality = {
  isCurrentIPInternal: () => Promise<boolean>;
};

const INTERNAL_IPS = new Set([
  "46.21.160.131",
  "46.21.160.132",
  "92.110.105.8",
  "92.60.82.109",
  "92.65.159.224",
  "2a02:a449:e049:1:",
  "2a02:a449:e049:0001:",
  "77.163.203.229",
]);

const IP_API_URL = "https://api64.ipify.org?format=json";

export const useFilterIPAddress = (): IPAddressFunctionality => {
  const isCurrentIPInternal = async (): Promise<boolean> => {
    try {
      const response = await axios.get<{ ip: string }>(IP_API_URL);
      const ipAddress = response.data.ip;
      return INTERNAL_IPS.has(ipAddress);
    } catch (error) {
      console.error("Failed to fetch IP address:", error);
      return false;
    }
  };

  return { isCurrentIPInternal };
};
